import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class DownTimeReasonStatusResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
